import { ReactElement } from 'react';
import { thumsuplogo } from 'src/assets/QuoteStatus';
import { superiorThumsup } from 'src/assets/QuoteStatus';
import { chevron_right } from 'src/assets/QuoteStatus';

const QualityGuaranteeTag = ({
  hideText = false,
  className = '',
  showChevron = false
}: {
  hideText?: boolean;
  className?: string;
  showChevron?: boolean;
}): ReactElement => {
  switch (hideText) {
  case false:
    return (
      <div
        className={`flex bg-primaryPurple1 h-6 rounded-2xl ${className} ${
          showChevron ? '' : 'w-[133px]'
        }`}>
        <img className="p-1" src={thumsuplogo} />
        <div className="text-xs font-semibold text-textViolet mt-1">Quality Guarantee</div>
        {/* Issue */}
        {showChevron && <img className='p-1' src={chevron_right} />} 
      </div>
    );
  case true:
    return <img src={superiorThumsup} />;
  }
};

export default QualityGuaranteeTag;
